import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  SCIENCE = 'Science',
  ENVIRONMENT = 'Environment',
  SPACE_ASTRONOMY = 'Space & Astronomy',
  ANTHROPOLOGY = 'Anthropology',
  BIOLOGY = 'Biology',
  PHYSICS = 'Physics',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['science'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['science/environment'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['science/space-astronomy'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['science/archaeology'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['science/biology'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['science/physics'] } }
    ]
  }
};

const ENVIRONMENT = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['science/environment'] } }]
  }
};

const SPACE_ASTRONOMY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['science/space-astronomy'] } }]
  }
};

const ANTHROPOLOGY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['science/archaeology'] } }]
  }
};

const BIOLOGY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['science/biology'] } }]
  }
};

const PHYSICS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['science/physics'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'science',
            'science/environment',
            'science/space-astronomy',
            'science/archaeology',
            'science/biology',
            'science/physics'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'science' } }, { prefix: { key: 'DJEThing', value: 'science/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, ENVIRONMENT, SPACE_ASTRONOMY, ANTHROPOLOGY, BIOLOGY, PHYSICS, RELATED_OPINION, VIDEO };
